import { gql, TypedDocumentNode } from '@apollo/client';

export type GiftCode = {
  __typename: 'RestGiftCode';
  id: string;
  attributes: {
    __typename: 'RestGiftCodeAttributes';
    code: string;
  };
};

export type GetAvailableGiftCodesQuery = {
  availableGiftCodes: {
    __typename: 'RestAvailableGiftCodes';
    data: GiftCode[];
  };
};

export const GET_AVAILABLE_GIFT_CODES_QUERY: TypedDocumentNode<GetAvailableGiftCodesQuery> = gql`
  query GetAvailableGiftCodesQuery {
    availableGiftCodes
      @rest(type: "RestAvailableGiftCodes", endpoint: "moda", path: "/v3.5/promotions") {
      data @type(name: "RestGiftCode") {
        id
        attributes @type(name: "RestGiftCodeAttributes") {
          code: offer_code
        }
      }
    }
  }
`;
